// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

/* Comita AML CSS 0.1 */
.ca-content {
  display: flex;
  flex: 1 0 auto;
  justify-content: center;
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  padding-top: 1.5rem;
  width: 100%;
}

.ca-content,
.h1,
.h2,
.h3,
.h4,
.h5 {
  color: var(--color-default);
}

.ca-content .h5 {
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.5;
}

.ca-content .ca-button {
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.5;
}

.ca-content .ca-button-light {
  /* Bootstrap variables (scss/_buttons.scss) */
  border: 0;
  color: var(--bs-btn-color);
  background: var(--bs-btn-bg);
  border-color: var(--bs-btn-border-color);
}
.ca-content .ca-button-light:hover {
  color: var(--bs-btn-hover-color);
  background: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
}
.ca-content .ca-button-light:active {
  color: var(--color-default);
  background: var(--bs-btn-active-bg);
  border-color: var(--bs-btn-active-border-color);
}
.ca-content .ca-button-light:disabled {
  color: var(--bs-btn-disabled-color);
  background: var(--bs-btn-disabled-bg);
  border-color: var(--bs-btn-disabled-border-color);
}
.ca-content .ca-button-light:focus:not(:focus-visible) {
  outline: 0;
  box-shadow: none;
}

.ca-content-medium {
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  width: 100%;
  padding: 0 0.5rem;
}

@media only screen and (min-width: 768px) {
  .ca-content-medium {
    width: 600px;
  }
}
.ca-row,
.ca-row-breadcrumb,
.ca-row-with-border {
  padding: 0.75rem 0.5rem;
}

.ca-row-breadcrumb {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.75rem;
}

.ca-row-with-border {
  padding-bottom: 1.75rem;
  margin-bottom: 0.75rem;
  border-bottom: 1px solid var(--border-color-light);
}

.ca-grid {
  display: grid !important;
  margin-top: 0.5rem;
}

.ca-footer {
  position: relative;
  padding-top: 2.375rem;
}

.form-text-size {
  font-size: 0.875em;
  color: var(--bs-secondary-color);
}`, "",{"version":3,"sources":["webpack://./src/monitor.scss"],"names":[],"mappings":"AACA;;;EAGE,sBAAA;AAAF;;AAIA,uBAAA;AAEA;EACE,aAAA;EACA,cAAA;EAEA,uBAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;AAFF;;AAKA;;;;;;EAME,2BAAA;AAFF;;AAIA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;AADF;;AAIA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;AADF;;AAGA;EACE,6CAAA;EACA,SAAA;EACA,0BAAA;EACA,4BAAA;EACA,wCAAA;AAAF;AACE;EACE,gCAAA;EACA,kCAAA;EACA,8CAAA;AACJ;AACE;EACE,2BAAA;EACA,mCAAA;EACA,+CAAA;AACJ;AAEE;EACE,mCAAA;EACA,qCAAA;EACA,iDAAA;AAAJ;AAGE;EACE,UAAA;EACA,gBAAA;AADJ;;AAMA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,WAAA;EACA,iBAAA;AAHF;;AAKA;EACE;IACE,YAAA;EAFF;AACF;AAMA;;;EAGE,uBAAA;AAJF;;AAMA;EACE,aAAA;EACA,8BAAA;EACA,sBAAA;AAHF;;AAKA;EACE,uBAAA;EACA,sBAAA;EACA,kDAAA;AAFF;;AAMA;EACE,wBAAA;EACA,kBAAA;AAHF;;AAOA;EACE,kBAAA;EACA,qBAAA;AAJF;;AAOA;EACE,kBAAA;EACA,gCAAA;AAJF","sourcesContent":["\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n\n/* Comita AML CSS 0.1 */\n\n.ca-content {\n  display: flex;\n  flex: 1 0 auto;\n  -webkit-box-pack: center;\n  justify-content: center;\n  --bs-gutter-x: 1.5rem;\n  --bs-gutter-y: 0;\n  padding-top: 1.5rem;\n  width: 100%;\n}\n\n.ca-content,\n.h1,\n.h2,\n.h3,\n.h4,\n.h5 {\n  color: var(--color-default);\n}\n.ca-content .h5 {\n  font-size: 1rem;\n  font-weight: 600;\n  line-height: 1.5;\n}\n\n.ca-content .ca-button {\n  font-size: 1rem;\n  font-weight: 600;\n  line-height: 1.5;\n}\n.ca-content .ca-button-light {\n  /* Bootstrap variables (scss/_buttons.scss) */\n  border: 0;\n  color: var(--bs-btn-color);\n  background: var(--bs-btn-bg);\n  border-color: var(--bs-btn-border-color);\n  &:hover {\n    color: var(--bs-btn-hover-color);\n    background: var(--bs-btn-hover-bg);\n    border-color: var(--bs-btn-hover-border-color);\n  }\n  &:active {\n    color: var(--color-default);\n    background: var(--bs-btn-active-bg);\n    border-color: var(--bs-btn-active-border-color);\n  }\n  \n  &:disabled {\n    color: var(--bs-btn-disabled-color);\n    background: var(--bs-btn-disabled-bg);\n    border-color: var(--bs-btn-disabled-border-color);\n  }\n  \n  &:focus:not(:focus-visible) {\n    outline: 0;\n    box-shadow: none;\n  }\n}\n\n\n.ca-content-medium {\n  display: flex;\n  flex: 0 0 auto;\n  flex-direction: column;\n  width: 100%;\n  padding: 0 0.5rem;\n}\n@media only screen and (min-width: 768px) {\n  .ca-content-medium {\n    width: 600px;\n  }\n}\n\n\n.ca-row,\n.ca-row-breadcrumb,\n.ca-row-with-border {\n  padding: 0.75rem 0.5rem;\n}\n.ca-row-breadcrumb {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 0.75rem;\n}\n.ca-row-with-border {\n  padding-bottom: 1.75rem;\n  margin-bottom: 0.75rem;\n  border-bottom: 1px solid var(--border-color-light);\n}\n\n\n.ca-grid {\n  display: grid !important;\n  margin-top: 0.5rem;\n}\n\n\n.ca-footer {\n  position: relative;\n  padding-top: 2.375rem;\n}\n\n.form-text-size {\n  font-size: .875em;\n  color: var(--bs-secondary-color)\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
